// js/Api/sip_settings.js
//
// SIP settings API — wraps the real /portalsip endpoints.
// Base path: ${REACT_APP_API_ORIGIN}/portalsip
//
// v1 assumption: a CW device has at most one SIP account. The GET endpoint
// may return an array; we use the first record. priority/isActive are
// hidden in the UI for now and always sent as defaults (0, true).

import { apiGet, apiPost, apiPut, apiDelete } from "./api_call/api_methods";

const BASE = `${process.env.REACT_APP_API_ORIGIN}/portalsip`;

const withDefaults = (body) => ({ ...body, priority: 0, isActive: true });

export const fetchSipForDevice = async (deviceId) => {
    if (!deviceId) {
        return { success: false, error: "Device ID is required" };
    }
    return apiGet({
        endpoint: `${BASE}/device/${deviceId}`,
        error_message: "Failed to fetch SIP settings",
    });
};

export const createSipForDevice = async (deviceId, body) => {
    if (!deviceId) {
        return { success: false, error: "Device ID is required" };
    }
    return apiPost({
        endpoint: `${BASE}/device/${deviceId}`,
        body: withDefaults(body),
        successMessage: "SIP account created",
        errorMessage: "Failed to create SIP account",
    });
};

export const updateSipAccount = async (sipAccountId, body) => {
    if (!sipAccountId) {
        return { success: false, error: "SIP account ID is required" };
    }
    return apiPut({
        endpoint: `${BASE}/${sipAccountId}`,
        body: withDefaults(body),
        successMessage: "SIP account updated",
        errorMessage: "Failed to update SIP account",
    });
};

export const deleteSipAccount = async (sipAccountId) => {
    if (!sipAccountId) {
        return { success: false, error: "SIP account ID is required" };
    }
    return apiDelete({
        endpoint: `${BASE}/${sipAccountId}`,
        successMessage: "SIP account deleted",
        errorMessage: "Failed to delete SIP account",
    });
};
